import createAxiosInstance from "./LambdaReclasificacionApi";

export async function GetFetchReporteCierreDia(
  branchFiPaisId,
  brandfiMarcaId,
  brandfiSucursalId,
  fechaIncio,
  fechaFin
) {
  const axiosInstance = await createAxiosInstance();
  const requestConfig = {
    method: "POST", // Cambia el método si es necesario
    url: `/reclasificacion`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      code: 4,
      params: {
        pais: branchFiPaisId,
        marca: brandfiMarcaId,
        sucursal: brandfiSucursalId,
        fechaInicio: fechaIncio,
        fechaFin: fechaFin,
      },
    },
  };

  return axiosInstance(requestConfig);
}
